/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M18 9.05A9 9 0 1 0 9 18a9 9 0 0 0 9-8.95Zm-9 8a8 8 0 1 1 8.05-8A8 8 0 0 1 9 17.04ZM7.35 7.9c-.3.48-1 1.77-2.88 5.4l-.73 1.38 1.49-.8c3.52-1.82 4.83-2.5 5.3-2.8l.26-.13 3.78-7.09-7.08 3.81Zm4.89-1.7-1.93 3.61c-.47-.47-1.21-1.2-1.68-1.68Zm-2.61 4.3-3.57 1.89 1.89-3.56c.47.47 1.2 1.19 1.67 1.67Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CompassIcon';

export default Icon;
